import React from "react";
import { Chart as ChartJS,CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend} from "chart.js";
import {Line} from 'react-chartjs-2';



ChartJS.register(CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend);

export default function GraficoAgro({ data, options }) {
  return <Line data={data} options={options} />;
}